<template>
  <div>
    <article class="box">
      <div v-for="setting in settings" :key="setting.key" class="field is-horizontal settings-container">
        <div class="field-label is-normal settings-label">
          <label>{{$t(setting.jsonStr)}}</label>
        </div>
        <div class="field-body">
          <div class="field settings-toggle">
            <toggle-switch v-model="setting.value" :class="setting.gtm" @input="save"></toggle-switch>
          </div>
        </div>
      </div>
      <div v-if="isStandardUser && $isOhioScience" class="field is-horizontal settings-container">
        <div class="field-label is-normal settings-label">
          <label>I am a Teacher</label>
        </div>
        <div class="field-body">
          <div class="field settings-toggle">
            <toggle-switch v-model="isTeacher" :disableToggle="isTeacherUser" @input="saveTeacher"></toggle-switch>
          </div>
        </div>
      </div>
      <div class="field is-horizontal settings-container">
        <div v-if="isAdmin" class="field-label-theme is-normal settings-label">
          <label>Theme</label>
        </div>
        <toggle-theme></toggle-theme>
      </div>
    </article>
    <article v-if="isAdmin" class="box">
      <h3>{{$t('sectionProfile.notificationsFrequency')}}</h3>
      <div class="control dropdown_container mt-4">
        <dropdown id="type" v-model="notificationFrequency" :items="frequencies" />
      </div>
    </article>
    <article v-if="isAdmin" class="box">
      <h3>Select Hour (UTC)</h3>
      <div class="control dropdown_container mt-4">
        <dropdown id="type" v-model="notificationHour" :items="allNotificationHours" />
      </div>
    </article>
    <article class="box categories">
      <h3>{{$t('sectionProfile.myInterests')}}</h3>
      <div class="user-tags is-flex mt-4">
        <a v-for="category in userCategoriesSorted" :key="category.name" @click="clickCategory(category)" class="gtm-category-tag">
          <span class="tag is-flex gtm-category-tag">
            {{category.parentID === 0 ? category.name.toUpperCase() : category.name}}
          </span>
        </a>
      </div>
      <div class="button is-primary edit-categories" @click="showModal()">{{$t('edit')}}</div>
    </article>
    <article class="box" v-if="user.signUpSource !== 'make_oauth'">
      <div class="field-label is-normal password-label"><h3>{{$t('sectionProfile.changePassword')}}</h3></div>
      <div class="field"> <input ref="password" type="password" class="input" v-model="oldPassword" :placeholder="$t('sectionProfile.enterCurrentPassword')"></div>
      <div class="field"><password ref="password" class="field" v-model="password" :oldPassword="oldPassword"></password></div>
      <div class="button is-primary" @click="savePassword">{{$t('save')}}</div>
    </article>
    <article class="box" v-if="user.signUpSource !== 'make_oauth'">
      <div class="field-label is-normal password-label"><h3>{{$t('sectionProfile.changeEmail')}}</h3></div>
      <div class="field"> <input ref="email" type="email" class="input" v-model="email" :placeholder="user.email"></div>
      <div class="button is-primary" @click="saveEmail">{{$t('save')}}</div>
    </article>
  <categories-modal ref="categoryModal" @categoriesChanged="fetchCategories"></categories-modal>
  <fade-message :message="message" :error="error" @clearMessage="message = ''" @clearError="error = ''"></fade-message>
    <custom-modal v-if="showConfirmTeacherModal"
                  title="Confirm Submit" text="Are you sure you want to become a teacher?"
                  successText="Yes" cancelText="Cancel"
                  hasFooter="true"
                  @modalSuccess="updateUserTypeToTeacher()"
                  @modalCancel="cancelTeacherUserUpdate()">
    </custom-modal>
  </div>
</template>

<script>
import ToggleSwitch from '@/components/Controls/ToggleSwitch'
import componentState from '@/mixins/component-state'
import state from '../state'
import Password from '@/components/Inputs/Password'

import SectionHeader from './About/SectionHeader'
import FadeMessage from '@/components/Controls/FadeMessage'
import CategoriesModal from '@/components/Modals/Categories'
import CategorySelector from '@/components/Inputs/CategorySelector'
import ToggleTheme from '@/components/Controls/ToggleTheme'
import store from '@/store'
import CategoryStar from '@/components/Controls/CategoryStar'
import Dropdown from '@/components/Controls/GenericComponents/dropdown'
import auth from '@/mixins/auth'
import i18n from '@/i18n'
import CustomModal from '@/components/Modals/Custom'
import userTypes from '@/mixins/user-types'

const settings = [
  {
    key: 'notifications',
    jsonStr: 'sectionProfile.emailNotifications',
    value: false,
    gtm: 'gtm-profile-email-settings'
  },
  {
    key: 'pushNotifications',
    jsonStr: 'sectionProfile.pushNotifications',
    value: false,
    gtm: 'gtm-profile-push-settings'
  },
  {
    key: 'receiveEmails',
    jsonStr: 'sectionProfile.marketingEmails',
    value: false,
    gtm: 'gtm-profile-marketing-email-settings'
  }
]

const frequencyMapping = {
  1: 'Instant ⚡',
  2: 'Daily Digest',
  3: 'Weekly Digest'
}

export default {
  props: ['user'],
  components: {
    ToggleSwitch,
    Password,
    FadeMessage,
    CategorySelector,
    SectionHeader,
    CategoriesModal,
    CategoryStar,
    ToggleTheme,
    Dropdown,
    CustomModal
  },
  mixins: [auth, componentState, userTypes],
  data: function () {
    return {
      settings,
      password: '',
      email: '',
      oldPassword: '',
      error: '',
      message: '',
      chosenCategories: [],
      editing: false,
      userCategories: [],
      notificationFrequency: '',
      notificationHour: 0,
      allNotificationHours: 0,
      frequencies: null,
      frequencyChange: false,
      isTeacher: false,
      showConfirmTeacherModal: false
    }
  },
  created: function () {
    this.fetchCategories()
    this.user = store.getters.currentUser
    if (this.$store.getters.currentUser.type === this.UserTypeTeacher) {
      this.isTeacher = true
    }
    this.settings.forEach((setting) => {
      this.$store.dispatch('getUserSetting', setting.key).then((value) => {
        setting.value = value
      })
    })
    this.$store.dispatch('getUserSetting', 'notificationsFrequency').then((value) => {
      this.notificationFrequency = frequencyMapping[value]
      const x = Object.keys(frequencyMapping).map(key => frequencyMapping[key])
      this.frequencies = x
    })

    this.$store.dispatch('getUserSetting', 'notificationsHour').then((value) => {
      this.notificationHour = value
      this.allNotificationHours = [...Array(24).keys()]
    })
  },
  computed: {
    userCategoriesSorted: function () {
      if (this.userCategories && this.userCategories.length > 0) {
        const parents = {}
        const categories = []
        this.userCategories.forEach((category) => {
          if (category.parentID !== 0 && !parents[category.parentID]) {
            const parent = this.$store.getters.categoryByID(category.parentID)
            if (parent) {
              categories.push(parent)
              parents[category.parentID] = true
            }
          }
          categories.push(category)
        })
        return categories
      }
      return []
    },
    isStandardUser: function () {
      return this.$store.getters.currentUser.type === this.UserTypeStandard
    },
    isTeacherUser: function () {
      return this.$store.getters.currentUser.type === this.UserTypeTeacher
    }
  },
  watch: {
    notificationFrequency: function (value) {
      const keyOfValue = Object.keys(frequencyMapping).find(key => frequencyMapping[key] === value)
      if ((this.user.UserSettings.notificationsFrequency !== Number(keyOfValue)) || this.frequencyChange) {
        const settings = { notificationsFrequency: Number(keyOfValue) }
        this.$store.dispatch('updateUserSettings', { username: this.user.userName, settings })
        this.frequencyChange = true
      }
    },
    notificationHour: function (value) {
      const settings = { notificationsHour: value }
      this.$store.dispatch('updateUserSettings', { username: this.user.userName, settings })
    }
  },
  methods: {
    fetchCategories: function () {
      this.$store.dispatch('getUserCategories', this.user.userName).then((categories) => {
        this.userCategories = categories
      })
    },
    update: function () {
      this.editing = false
      const categories = this.chosenCategories ? this.chosenCategories.map((category) => category.id) : []
      this.$store.dispatch('setUserCategories', { username: this.user.userName, categories }).then((categories) => {
        this.userCategories = categories
        this.message = i18n.t('sectionProfile.updateCategoriesSuccess')
      }, () => {
        this.error = i18n.t('sectionProfile.updateCategoriesFail')
      })
    },
    save: function (setting) {
      const data = {}
      this.settings.forEach((setting) => {
        data[setting.key] = setting.value
      })
      this._callback(state.callbacks.save.settings, data)
    },
    savePassword: function () {
      const params = { username: this.user.userName, password: this.password, oldPassword: this.oldPassword }
      this.$store.dispatch('setPassword', params).then(() => {
        this.message = i18n.t('sectionProfile.updatePasswordSuccess')
        this.oldPassword = ''
        this.$refs.password.clear()
      }, () => {
        this.error = i18n.t('sectionProfile.updatePasswordFail')
      })
    },
    saveEmail: function () {
      const params = { username: this.user.userName, email: this.email }
      this.$store.dispatch('setEmail', params).then(() => {
        this.message = i18n.t('sectionProfile.updateEmailSuccess')
        this.user.email = this.email
        this.email = ''
        this.$refs.email.clear()
      }, (error) => {
        if (error.message === 'Email already exists') {
          this.error = i18n.t('sectionProfile.updateEmailAlreadyExists')
        } else {
          this.error = i18n.t('sectionProfile.updateEmailFail')
        }
      })
    },
    toggleEditCategories: function () {
      this.chosenCategories = this.userCategories.slice()
      this.editing = !this.editing
    },
    clickCategory: function (category) {
      if (category.subCategories && category.subCategories.length > 0) {
        this.$router.push({ name: 'projectsCategory', params: { category: category.slug } })
      } else {
        this.$router.push({ name: 'viewAll', query: { category: category.slug } })
      }
    },
    showModal: function () {
      this.$refs.categoryModal.showModal('profile')
    },
    updateUserTypeToTeacher: function () {
      this.$store.dispatch('updateEventAndPartnerIDs', { username: this.$store.getters.currentUser.userName }).then(() => {
        this.showConfirmTeacherModal = false
      })
      this.$store.dispatch('updateUserType', { username: this.$store.getters.currentUser.userName, userType: this.UserTypeTeacher }).then(() => {
        this.showConfirmTeacherModal = false
      })
    },
    saveTeacher: function () {
      this.showConfirmTeacherModal = true
    },
    cancelTeacherUserUpdate: function () {
      this.isTeacher = false
      this.showConfirmTeacherModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .password-label {
    text-align: left;
  }

  .categories-wrapper{
    justify-content: flex-start;
    flex-wrap: wrap;
    .a-category {
      display: inline-block;
      height: inherit;
    }
    .tag {
      margin-right: 0.3rem;
      font-size: 0.8rem;
      color: white;
      border-radius: 0;
      margin-bottom: 0.3rem;
    }
  }

  h3 {
    font-weight: 600;
  }
  .user-categories {
    align-items: center;
    margin-top: 1rem;
    @include mobile {
      flex-direction: column;
    }
  }
  .categories-wrapper {
    justify-content: flex-start;
  }
  .category {
    margin-right: 1.5rem;
    @include mobile {
      margin: 0.25rem 0.75rem;
    }
  }
  .category-image {
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    @include mobile {
      width: 75px;
      height: 75px;
    }
  }
  .category-name {
    width: 90px;
    text-align: center;
    margin-top: 0.25rem;
    @include mobile {
      width: 75px;
    }
  }
  .edit-categories {
    margin-top: 1rem;
    margin-left: 0;
    @include mobile {
      margin-left: 0;
    }
  }

  .settings-container {
    display: flex;
    align-items: center;
    .settings-label {
      flex: 0 0 150px;
      padding-top: 0;
      text-align: left;
      font-weight: 600;
      @include mobile {
        margin-bottom: 0;
        margin-right: 1rem;
      }
    }
  }

  .button {
    border-radius: 0;
  }
  .user-tags {
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .tag {
    margin: 0.15rem 0.3rem 0.15rem 0;
    font-size: 0.8rem;
    margin-bottom: 0.3rem;
    color: $grey-dark;
    background-color: $white;
    border-radius: 2px;
    border: 1px solid $grey-light;
  }
  .field-label-theme {
    margin-right: 5.1px;
  }
</style>
